// extracted by mini-css-extract-plugin
export default {"Container":"WorkoutSlideItem_Container__+lAFU"};